import { Injectable } from '@angular/core';
import {Observable} from "rxjs";
import {catchError} from "rxjs/operators";
import {BaseService} from "./base.service";
import { HttpClient, HttpParams, HttpResponse } from "@angular/common/http";
import {MatSnackBar} from "@angular/material/snack-bar";
import {HelperService} from "../helper.service";
import { NewPin } from '../models/NewPin ';
import { nTesterPin } from '../models/nTesterPin';
import { PinType } from '../models/pinType';
import { PageModel } from '../models/page-model';
import { yieldEstimationPin } from '../models/yieldEstimationPin';
import { yieldEstimationUnitOfmeasure } from '../models/yieldEstimationUnitOfMeasure';
import {GrowthStageModel} from "../models/growth-stage";
import { Farm } from '../models/farm';
import { NavBarComponent } from '../nav-bar/nav-bar.component';

@Injectable({
  providedIn: 'root'
})
export class PinManagerService extends BaseService {

  private API_PIN_MANAGEMENT_URL = this.API_BASE_URL + "pin-management"; 

  constructor(
      private httpClient: HttpClient,
      public snackBar: MatSnackBar,
      public helper: HelperService,
      public nav: NavBarComponent,
  ) {
    super();
  }


  /// GET ///
  getPinTypesList(): Observable<PinType[]> {
    return this.httpClient.get<PinType[]>(this.API_PIN_MANAGEMENT_URL + '/pins/types')
        .pipe(
            catchError((err) => {
              this.hasError.next(true);
              this.snackBar.open('Error Retrieving Pin Type List','close', {
                duration: 5000,
              });
              this.hasError.next(false);
              return this.errorHandler(err);
            })
        );
  }

  getGrowthStageMetaData(currentCropId: number) {
      let params = {};
      if(currentCropId) {
          params = new HttpParams()
              .set('cropId', currentCropId?.toString())
      }
      return this.httpClient.get<GrowthStageModel[]>(this.API_PIN_MANAGEMENT_URL + '/metadata/growth', {params});
  }


  getAllPaginatedPinsListByTenantId(tenantId:number, page: number, size: number,searchQuery?:string, fromDate?:string, toDate?: string, pinTypeId?: number | null): Observable<PageModel<NewPin[]>> {

    
    let params = new HttpParams()
        .set('page', page.toString())
        .append('size', size.toString())

     if (tenantId) {
          params = params.append('tenantId', tenantId.toString());
      }

    if (searchQuery) {
        params = params.append('searchQuery', searchQuery);
    }

    if (fromDate) {
        params = params.append('fromDate', fromDate);
    }

    if (toDate) {
        params = params.append('toDate', toDate);
    }

    if (pinTypeId) {
      params = params.append('pinTypeId', pinTypeId.toString());
  }

    return this.httpClient.get<PageModel<NewPin[]>>(this.API_PIN_MANAGEMENT_URL + `/pins/all`, {params})
        .pipe(
            catchError((err) => {
                this.hasError.next(true);
                this.snackBar.open('Error Retrieving All Pin List','close', {
                    duration: 5000,
                });
                this.hasError.next(false);
                return this.errorHandler(err);
            })
        );
}


getSavedPinsByFieldId(fieldId:number, tenantId:number, fromDate:string, toDate: string): Observable<NewPin[]> {
  return this.httpClient.get<NewPin[]>(this.API_PIN_MANAGEMENT_URL + `/pins?fieldId=${fieldId}&tenantId=${tenantId}&fromDate=${fromDate}&toDate=${toDate}`)
      .pipe(
          catchError((err) => {
            this.hasError.next(true);
            this.snackBar.open('Error Retrieving Saved Pins List','close', {
              duration: 5000,
            });
            this.hasError.next(false);
            return this.errorHandler(err);
          })
      );
}


  getSavedPinsByFarmId(farmId:number, tenantId:number, fromDate:string, toDate: string): Observable<NewPin[]> {
    return this.httpClient.get<NewPin[]>(this.API_PIN_MANAGEMENT_URL + `/pins?farmId=${farmId}&tenantId=${tenantId}&fromDate=${fromDate}&toDate=${toDate}`)
        .pipe(
            catchError((err) => {
              this.hasError.next(true);
              this.snackBar.open('Error Retrieving Saved Pins List','close', {
                duration: 5000,
              });
              this.hasError.next(false);
              return this.errorHandler(err);
            })
        );
  }


  getSavedPinById(pinId:number): Observable<NewPin> {
    return this.httpClient.get<NewPin>(this.API_PIN_MANAGEMENT_URL + `/pins/${pinId}`)
        .pipe(
            catchError((err) => {
              this.hasError.next(true);
              this.snackBar.open('Error Retrieving Saved Pins List','close', {
                duration: 5000,
              });
              this.hasError.next(false);
              return this.errorHandler(err);
            })
        );
  }

  getSavedNTesterPinById(pinId:number): Observable<nTesterPin> {
    return this.httpClient.get<nTesterPin>(this.API_PIN_MANAGEMENT_URL + `/pins/${pinId}/n-tester`)
        .pipe(
            catchError((err) => {
              this.hasError.next(true);
              this.snackBar.open('Error Retrieving Saved Pins List','close', {
                duration: 5000,
              });
              this.hasError.next(false);
              return this.errorHandler(err);
            })
        );
  }

  getYieldestimationPinById(pinId:number): Observable<yieldEstimationPin> {
    return this.httpClient.get<yieldEstimationPin>(this.API_PIN_MANAGEMENT_URL + `/pins/${pinId}/yield-estimation`)
        .pipe(
            catchError((err) => {
              this.hasError.next(true);
              this.snackBar.open('Error Retrieving Saved Pins List','close', {
                duration: 5000,
              });
              this.hasError.next(false);
              return this.errorHandler(err);
            })
        );
  }

  getYieldestimationUnitOfmeasure(): Observable<yieldEstimationUnitOfmeasure[]> {
    return this.httpClient.get<yieldEstimationUnitOfmeasure[]>(this.API_PIN_MANAGEMENT_URL + `/metadata/unit-of-measure`)
        .pipe(
            catchError((err) => {
              this.hasError.next(true);
              this.snackBar.open('Error Retrieving Saved Pins List','close', {
                duration: 5000,
              });
              this.hasError.next(false);
              return this.errorHandler(err);
            })
        );
  }


  getfarmsByTenantId(tenantId:number): Observable<any[]> {
        let params = new HttpParams();

        if(tenantId){
            params = params.append('tenantId', tenantId);
        }

  return this.httpClient.get<any[]>(this.API_PIN_MANAGEMENT_URL + `/farms`,{ params: params})
      .pipe(
          catchError((err) => {
            this.hasError.next(true);
            this.snackBar.open('Error Retrieving Saved Pins List','close', {
              duration: 5000,
            });
            this.hasError.next(false);
            return this.errorHandler(err);
          })
      );
}

  getfieldsByTenantId(tenantId:number, farmId?:number[]): Observable<any[]> {
        const fieldBody = {
            tenantId: tenantId,
            farmId: farmId || []
        }

  return this.httpClient.post<any[]>(this.API_PIN_MANAGEMENT_URL + `/fields`, fieldBody)
      .pipe(
          catchError((err) => {
            this.hasError.next(true);
            this.snackBar.open('Error Retrieving Saved Pins List','close', {
              duration: 5000,
            });
            this.hasError.next(false);
            return this.errorHandler(err);
          })
      );
}

      postExportPinsAsExcel(tenantId:number, farmId?:number[] | null, fieldId?:number[] | null, pinTypeId?:number[] | null, fromDate?: string, toDate?:string): Observable<{ download_url: string }> {

        const excelBody: any = {
            tenantId: tenantId
        };
        
        if (farmId && farmId.length > 0) {
            excelBody.farmId = farmId;
        }
        if (fieldId && fieldId.length > 0) {
            excelBody.fieldId = fieldId;
        }
        if (pinTypeId && pinTypeId.length > 0) {
            excelBody.pinTypeId = pinTypeId;
        }
        if (fromDate) {
            excelBody.fromDate = fromDate;
        }
        if (toDate) {
            excelBody.toDate = toDate;
        }
        
        return this.httpClient.post<{ download_url: string }>(this.API_BASE_URL + 'data-management/export/pins/excel', excelBody)
            .pipe(
                catchError((err) => {
                    this.hasError.next(true);
                    this.snackBar.open('Error Exporting Pins to Excel file - please try diffirent filter options','close', {
                        duration: 5000,
                    });
                    this.nav.toggleLoading(false);
                    this.hasError.next(false);
                    return this.errorHandler(err);
                })
            );
    }


    postExportPinsToZipShpFile(tenantId:number, farmId?:number[] | null, fieldId?:number[] | null, pinTypeId?:number[] | null, fromDate?: string, toDate?:string): Observable<{ download_url: string }> {

        const shpBody: any = {
            tenantId: tenantId
        };
        
        if (farmId && farmId.length > 0) {
            shpBody.farmId = farmId;
        }
        if (fieldId && fieldId.length > 0) {
            shpBody.fieldId = fieldId;
        }
        if (pinTypeId && pinTypeId.length > 0) {
            shpBody.pinTypeId = pinTypeId;
        }
        if (fromDate) {
            shpBody.fromDate = fromDate;
        }
        if (toDate) {
            shpBody.toDate = toDate;
        }
        return this.httpClient.post<{ download_url: string }>(this.API_BASE_URL + 'data-management/export/pins/shapefile', shpBody)
            .pipe(
                catchError((err) => {
                    this.hasError.next(true);
                    this.snackBar.open('Error Exporting Pins as shp file zip - please try diffirent filter options ','close', {
                        duration: 5000,
                    });
                    this.nav.toggleLoading(false);
                    this.hasError.next(false);
                    return this.errorHandler(err);
                })
            );
    }

    getUsersByTenantId(tenantId: number): Observable<any[]> {
        return this.httpClient.get<any[]>(this.API_PIN_MANAGEMENT_URL + `/users?tenantId=${tenantId}`)
            .pipe(
                catchError(error => {
                    console.error(error);
                    return this.errorHandler(error);
                })
            );
    }



    //POST
    postNewPin(pinTypeId: number, fieldId: string, userId: string, tenantId:number, description:string, lat:string, lng:string): Observable<any> {
        const pinBody = {
            pinTypeId: pinTypeId,
            fieldId: fieldId,
            userId: userId,
            tenantId: tenantId,
            description: description,
            lat: lat,
            lng: lng,
        }
        // 
        
        return this.httpClient.post<any>(this.API_PIN_MANAGEMENT_URL + '/pins',pinBody)
            .pipe(
                catchError((err) => {
                    this.hasError.next(true);
                    this.snackBar.open('Error Creating New Pin','close', {
                        duration: 5000,
                    });
                    this.hasError.next(false);
                    return this.errorHandler(err);
                })
            );
    }

    /// PUT ///
    updatePinById(id: number, description: string): Observable<NewPin> {
      const body = { description: description };
      return this.httpClient.put<NewPin>(this.API_PIN_MANAGEMENT_URL +`/pins/${id}`, body)
          .pipe(
              catchError((err) => {
                  this.hasError.next(true);
                  this.snackBar.open('Error Updating New Pin','close', {
                      duration: 5000,
                  });
                  this.hasError.next(false);
                  return this.errorHandler(err);
              })
          );
  }

  updateYieldEstimationPinById(pinId: number, description?: string, unitOfMeasureId?: number, yieldEstimation?: number, yieldWeightedValue?: number, estimationDate?: string): Observable<yieldEstimationPin> {
    const body = { 
      description: description,
      unitOfMeasureId: unitOfMeasureId,
      yieldEstimation: yieldEstimation,
      yieldWeightedValue: yieldWeightedValue,
      estimationDate: estimationDate,
    };
    return this.httpClient.put<yieldEstimationPin>(this.API_PIN_MANAGEMENT_URL +`/pins/${pinId}/yield-estimation`, body)
        .pipe(
            catchError((err) => {
                this.hasError.next(true);
                this.snackBar.open('Error Updating New Pin','close', {
                    duration: 5000,
                });
                this.hasError.next(false);
                return this.errorHandler(err);
            })
        );
}

  convertMarkerToVcPinById(pinId: number): Observable<NewPin> {
    
    const body = {};
    return this.httpClient.put<NewPin>(this.API_PIN_MANAGEMENT_URL +`/pins/${pinId}/convert`, body)
        .pipe(
            catchError((err) => {
                this.hasError.next(true);
                this.snackBar.open('Error converting marker','close', {
                    duration: 5000,
                });
                this.hasError.next(false);
                return this.errorHandler(err);
            })
        );
}


//  DELETE ///
deletePinById(id: number): Observable<any> {
  
  return this.httpClient.delete(this.API_PIN_MANAGEMENT_URL + `/pins/${id} `)
      .pipe(
          catchError((err) => {
              this.hasError.next(true);
              this.snackBar.open('Error Removing  Pin ','close', {
                  duration: 5000,
              });
              this.hasError.next(false);
              return this.errorHandler(err);
          })
      );
}

}
